import { render, staticRenderFns } from "./unit-quantities-horizontal.vue?vue&type=template&id=31e66619&scoped=true&"
import script from "./unit-quantities-horizontal.vue?vue&type=script&lang=js&"
export * from "./unit-quantities-horizontal.vue?vue&type=script&lang=js&"
import style0 from "./unit-quantities-horizontal.vue?vue&type=style&index=0&id=31e66619&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e66619",
  null
  
)

export default component.exports